import { type FunctionComponent } from 'react';
import { SvgIcon, type SvgIconProps } from './SvgIcon';

export const ChevronRightIcon: FunctionComponent<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props}>
      <path d="M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
    </SvgIcon>
  );
};
